<template>
  <div
    class="flex flex-row items-center gap-4 w-full border rounded-xl p-4 bg-white z-10 border-gray-200"
    :class="{
      '!border-red-500': hasErrors(file),
      '!border-green-500 !bg-green-50 hover:!bg-green-50 cursor-default pointer-events-none':
        !hasErrors(file) && file.uploadProgress === 1.1,
    }"
  >
    <div class="grow-0 shrink-0">
      <div
        class="p-1 rounded-full aspect-square bg-brand-50"
        :class="{
          '!bg-red-50': hasErrors(file),
          '!bg-green-50': !hasErrors(file) && file.uploadProgress === 1.1,
        }"
      >
        <FileFive
          class="text-brand-600 w-7 h-7 p-1.5 rounded-full aspect-square bg-gray-100 overflow-visible"
          :class="{
            '!text-red-600 !bg-red-100': hasErrors(file),
            '!text-green-500 !bg-green-100':
              !hasErrors(file) && file.uploadProgress === 1.1,
          }"
        />
      </div>
    </div>
    <div class="grow flex flex-col items-stretch">
      <div
        class="text-sm font-medium flex flex-row justify-between text-gray-700"
      >
        <p>
          {{ file.title }}
        </p>
        <TrashOne
          v-if="file.uploadProgress === 0 && withTrash"
          @click.stop="emit('delete', file.id)"
          class="text-gray-500 hover:text-gray-800 w-5 h-5 cursor-pointer"
        />
      </div>
      <p class="text-sm text-gray-600 text-left">
        {{ formatBytes(file.size) }}
      </p>
      <!-- Progress bar -->
      <div
        v-if="file.uploadProgress > 0 && !hasErrors(file)"
        class="relative w-full h-1 rounded-full bg-gray-200 overflow-hidden mt-2"
      >
        <div
          class="absolute top-0 left-0 h-full max-w-full bg-brand-700 rounded-full"
          :class="{
            '!bg-green-500': !hasErrors(file) && file.uploadProgress === 1.1,
          }"
          :style="{
            width: file.uploadProgress * 100 + '%',
          }"
        />
      </div>
      <Errors class="mt-2" v-if="hasErrors(file)" :errors="file.errors" />
    </div>
  </div>
</template>

<script setup>
import FileFive from "@/Tailwind/Icon/FileFive";
import TrashOne from "@/Tailwind/Icon/TrashOne";
import { formatBytes } from "@/Tailwind/Helpers/size";
import Errors from "@/Tailwind/Components/Errors.vue";

defineProps({
  file: {
    type: Object,
    required: true,
  },
  withTrash: {
    type: Boolean,
  },
});

const emit = defineEmits(["delete"]);

const hasErrors = (file) => {
  return Object.values(file.errors).length > 0;
};
</script>
